export default __webpack_public_path__ + "static/media/wood4.7ca79263.jpg";